import { api } from "@/builders/axios";
import { ChaptersData, CreateChapter } from "@/builders/types/chapters";

const get = function (id: number) {
  return api.get<ChaptersData>(`/chapters/${id}`).then(({ data }) => data);
};

const put = function (variables: { id: number; data: CreateChapter }) {
  const { id, data } = variables;
  return api.put(`/chapters/${id}`, data).then(({ data }) => data);
};

const patch = function (id: number, data: ChaptersData) {
  return api.patch(`/chapters/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/chapters/${id}`);
};

export const id = {
  get,
  put,
  patch,
  del,
};
